import { findAncestor } from '@helpers/findAncestor';
import { loadSession, saveSession, removeSession } from '@helpers/sessionStorage';
import { TRACK_REAL_LIST_VALUE } from '../constants/GaTrackStorageKeys';

export const getRealListValue = () => loadSession(TRACK_REAL_LIST_VALUE);

export const setRealListValue = (value, event) => {
    if (value === undefined) {
        return;
    }

    const eventType = event ? event.type : null;

    if (eventType === 'contextmenu') {
        window.temporaryRealList = !getRealListValue() ? '' : getRealListValue();
        saveSession(TRACK_REAL_LIST_VALUE, value);

        if (typeof window.temporaryRealList !== 'undefined') {
            document.addEventListener('click',
                () => {
                    saveSession(TRACK_REAL_LIST_VALUE, window.temporaryRealList);
                    delete window.temporaryRealList;
                },
                { once: true });
        }
    } else {
        saveSession(TRACK_REAL_LIST_VALUE, value);
    }
};

export const removeRealListValue = () => removeSession(TRACK_REAL_LIST_VALUE);

const RealListTracker = () => {
    const checkoutClickHandler = (e) => {
        const isCheckoutProduct = !!findAncestor(e.target, 'item-link') || !!findAncestor(e.target, 'item-info');

        if (isCheckoutProduct) {
            setRealListValue('checkout');
        }
    };

    const miniCartClickHandler = (e) => {
        const isMiniCartProduct = !!findAncestor(e.target, 'mb-product__image');

        if (isMiniCartProduct) {
            setRealListValue('mini-cart');
        }
    };

    const listingClickHandler = (e) => {
        const isProductCardLink = !!findAncestor(e.target, 'p-card__link') || !!findAncestor(e.target, 'p-card__thumbs__link');
        const { realListTracking } = App.Config.Listing;

        if (isProductCardLink && realListTracking) {
            setRealListValue(realListTracking, e);
        }
    };

    const initEvent = () => {
        if (App.Config.Controller !== 'product') {
            removeRealListValue();
        }

        if (App.Config.Controller === 'listing' || App.Config.Controller === 'search') {
            document.addEventListener('click', listingClickHandler);
            document.addEventListener('contextmenu', listingClickHandler);
        }

        if (App.Config.Controller === 'checkout') {
            document.addEventListener('click', checkoutClickHandler);
        }

        document.addEventListener('click', miniCartClickHandler);
    };

    return {
        init: initEvent
    };
};

export default RealListTracker();
